import { Component } from '@angular/core';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { AllHughesNetMacs } from '../../../../models';

import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { Observable } from 'rxjs';
import { Validators } from '@angular/forms';

@Component({
  selector: 'manage-macs',
  templateUrl: './manageMacs.component.html',
  providers: [MainGridService],
  styleUrls: ['./manageMacs.component.css']
})
export class ManageMacsComponent {

  constructor(private transferHttp: TransferHttpService,
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>) { }

  //***************************
  // Variables
  //***************************
  user = this.transferHttp.getCache('user');

  titleText: string = "Manage Mac Addresses";
  headerText: string = this.titleText;
  macRule = { 'A': { pattern: new RegExp( '\[0-9A-Fa-f\]' )}};

  //Grid
  public macAddresses: Observable<any> = this.mainGridService.getAll(
    'IT/GetAllMacAddresses',
    'Common/SaveArctecMac',
    'Common/DeleteArctecMac');

  // AimsCommonTable setup
  tablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: true,
    delete: true,
    export: false
  };
  header: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', editable: false, filter: false },
    { key: 'hughesNetUserId', label: 'User', type: 'dynamic', width: 200,  editable: true, events: { filterAndSortCompare: (term, el) => {
            return el.fullName ? el.fullName.toLowerCase().includes(term) : false;
            } } },
    { key: 'active', label: "Active", type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN, width: 60, editable: false },
    { key: 'maxEffectiveDate', label: 'Max Date', type: AimsCommonTableHeaderType.DATE, editable: true, },
    { key: 'macAddress', label: 'MAC Address', type: 'dynamic', editable: true, validatorOrOpts: [Validators.required ] },
    { key: 'deviceType', label: 'Device Type', type: 'string', editable: true, validatorOrOpts: [Validators.required ] },
    { key: 'comment', label: 'Comment', type: 'string', editable: true, },
  ];
  addRowInitialObject = {
    hughesNetUserId: 0,
    maxEffectiveDate: null,
    macAddress: null,
    deviceType: null,
    comment: null
  }

  // aims table
  defaultTableState = { filter:{'active': true }};

  //Dropdown Values
  hughesNetUsers = this.transferHttp.getHot('IT/GetAllHughesNetUsers');
  hughesNetUserTypes = this.transferHttp.getHot('IT/GetHughesNetUserTypes');
  employees = this.transferHttp.getCache(CacheItem.allEmployees);

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = true;

  //***************************
  // Methods
  //***************************

  public handleRowAdd(update: TableRowUpdate): void {
    const mac = update.newRow as AllHughesNetMacs;
    mac.hughesNetMacId = 0;
    this.mainGridService.add(mac as any).subscribe(update.handleSubscribe())
  }

  handleRowDelete(deleted: TableRowDelete) {
    const row = deleted.row as AllHughesNetMacs;
    this.mainGridService.delete(row.hughesNetMacId, 'hughesNetMacId', deleted.index)
      .subscribe(deleted.handleSubscribe());
  }

  public handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe());
  }

  //***************************
  // Init
  //***************************
  ngOnInit(): void {
    this.macAddresses.subscribe(macs => this.showSpinner = false);
  }

}
